import React from "react";
import { Collapse, TableCell, TableRow } from "@mui/material";
import WorkOrderRoutingLabor from "../WorkOrderRoutingTable/WorkOrderRoutingLabor";
import { useGetLaborDataByRouteId } from "../../hooks";

const WorkOrderRoutingSubRow = ({ showQuantity = false, routeId, isOpen }) => {
  const getRoute = isOpen ? routeId : false;
  const { isLoading } = useGetLaborDataByRouteId(getRoute);

  const sx = isOpen
    ? { ":hover": { backgroundColor: "transparent !important" } }
    : { border: "none" };

  return (
    <TableRow sx={sx}>
      <TableCell
        colSpan={showQuantity ? 10 : 9}
        sx={{ padding: "0px !important" }}
      >
        <Collapse in={isOpen && !isLoading && routeId}>
          <WorkOrderRoutingLabor routeId={getRoute} />
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default WorkOrderRoutingSubRow;
